'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Icon = require('../../components/Icon');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ListItem = function ListItem(_ref) {
  var id = _ref.id,
      info = _ref.info,
      detail = _ref.detail,
      showDetail = _ref.showDetail,
      _onClick = _ref.onClick;
  return _react2.default.createElement(
    'div',
    { key: id, className: (0, _classnames2.default)('row', { active: showDetail }) },
    info && _react2.default.createElement(
      'div',
      {
        className: (0, _classnames2.default)('info', { 'has-detail': detail }),
        onClick: function onClick() {
          return _onClick(id);
        } },
      info.map(function (i) {
        return _react2.default.createElement(
          'div',
          { className: 'info-item' },
          i
        );
      }),
      _react2.default.createElement(
        'div',
        { className: 'info-expand-icon' },
        _react2.default.createElement(_Icon2.default, { icon: 'angle-down' })
      )
    ),
    detail && _react2.default.createElement(
      'div',
      { className: 'detail' },
      detail.map(function (d) {
        return _react2.default.createElement(
          'div',
          { className: 'detail-item' },
          d
        );
      })
    )
  );
};

exports.default = ListItem;